// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","background":"App_background__Ff1yf"};